/**
 * authFetch — a thin wrapper around window.fetch that:
 *  - Automatically injects the Bearer token from localStorage
 *  - Detects 401 (expired / invalid token), clears auth state,
 *    and redirects the user to /admin/login?reason=session_expired
 *
 * Use this for every authenticated admin API call so stale tokens
 * can never leave the UI stuck in a silent spinner / empty-list state.
 */

let _redirecting = false;

const handleUnauthorized = () => {
  if (_redirecting) return;
  _redirecting = true;
  try {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  } catch (_) {
    // ignore storage errors
  }
  // Preserve the page they were on so they can return after re-login
  const nextPath = window.location.pathname + window.location.search;
  const target = `/admin/login?reason=session_expired&next=${encodeURIComponent(nextPath)}`;
  // Full reload — simplest way to flush any stale app state
  window.location.replace(target);
};

export const authFetch = async (url, options = {}) => {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(url, { ...options, headers });
  if (res.status === 401) {
    handleUnauthorized();
    // Throw so callers short-circuit; the redirect has already started.
    throw new Error('Session expired');
  }
  return res;
};

export default authFetch;
